export const TAG_CLEAR_STORE = "TAG_CLEAR_STORE";

export const TAG_NEW_SAVE_START = "TAG_NEW_SAVE_START";
export const TAG_NEW_SAVE_SUCCESS = "TAG_NEW_SAVE_SUCCESS";
export const TAG_NEW_SAVE_FAIL = "TAG_NEW_SAVE_FAIL";

export const TAG_SAVE_START = "TAG_SAVE_START";
export const TAG_SAVE_SUCCESS = "TAG_SAVE_SUCCESS";
export const TAG_SAVE_FAIL = "TAG_SAVE_FAIL";

export const TAG_DETAIL_START = "TAG_DETAIL_START";
export const TAG_DETAIL_SUCCESS = "TAG_DETAIL_SUCCESS";
export const TAG_DETAIL_FAIL = "TAG_DETAIL_FAIL";
